import { createFileRoute } from "@tanstack/react-router";
import Blog from "@/pages/Blog";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/blog/")({
  head: () =>
    seo({
      title: "Roofing & Siding Blog for Minnesota Homeowners",
      description:
        "Practical guides on roof repair, LP SmartSide siding, ice dams, and storm damage—written by the Cedar Creek Construction crew for Minnesota homes.",
      path: "/blog",
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Blog", path: "/blog" },
      ]),
    }),
  component: Blog,
});
